/** @format */

import React from 'react';
import styled from 'fe-styled-components';
import PropTypes from 'prop-types';

const DEFAULT_IMAGE_SIZE = 100;
const MOBILE_IMAGE_SIZE = 60;

const PROP_TYPES = {
  oneX: PropTypes.string,
  twoX: PropTypes.string.isRequired,
  size: PropTypes.number,
  mobileSize: PropTypes.number,
  isRounded: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

const DEFAULT_PROPS = {
  size: DEFAULT_IMAGE_SIZE,
  mobileSize: MOBILE_IMAGE_SIZE,
  isRounded: false,
};

const BorderRadius = styled.div`
  ${(p) => (p.isRounded ? `border-radius: ${p.size * 0.1}px` : null)};

  @media (max-width: ${(p) => p.theme.breakpointMd}) {
    ${(p) => (p.isRounded ? `border-radius: ${p.mobileSize * 0.1}px` : null)};
  }
`;

const LogoBg = BorderRadius.extend`
  background-color: ${(p) => p.theme.colorWhite};
  flex-shrink: 0;
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;

  @media (max-width: ${(p) => p.theme.breakpointMd}) {
    width: ${(p) => p.mobileSize}px;
    height: ${(p) => p.mobileSize}px;
  }
`;

const LogoImg = BorderRadius.extend`
  width: 100%;
  min-width: 100%;
`.withComponent('img');

const Logo = ({ oneX, twoX, size, mobileSize, isRounded, title }) => (
  <LogoBg size={size} mobileSize={mobileSize} isRounded={isRounded}>
    <LogoImg
      src={twoX}
      srcSet={oneX && `${oneX}, ${twoX} 2x`}
      size={size}
      mobileSize={mobileSize}
      isRounded={isRounded}
      alt={`${title} logo`}
    />
  </LogoBg>
);

Logo.propTypes = PROP_TYPES;
Logo.defaultProps = DEFAULT_PROPS;

export default Logo;
